export default window.__STATE__ || {
  api: {},
  premium: {}
};
